import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { useSelector } from "react-redux";
import Plus from "../../assets/svgs/Plus.svg";
import sortAsce from "../../assets/svgs/sort-ascending.svg";
import sortDesc from "../../assets/svgs/sort-descending.svg";
import Loader from "../../components/Loader";
import swap from "../../assets/svgs/swap-vertical.svg";
import ActionsMenu from "../../components/ActionsMenu";
import DeleteConfirmationModal from "../../components/ConfirmationModals/DeleteConfirmationModal";
import { Skeleton } from "@chakra-ui/react";
import ContactPagination from "../../components/Pagination/ContactPagination";
import DataAsOfNotice from "../../components/DataAsOfNotice";
import useAuth from "../../hooks/useAuth";
import BaseLayout from "../../layouts/BaseLayout";
import { BASE_URL } from "../../utils/Element";
import AddLeadTypeModal from "./modals/LeaseTypeModals/AddLeadTypeModal";
import EditLeadTypeModal from "./modals/LeaseTypeModals/EditLeadTypeModal";

const LeadType = () => {
    const [config] = useAuth();
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);
    const [leadsData, setLeadsData] = useState([]);
    const [selectedId, setSelectedId] = useState("");
    const [showmodal, setShowModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemPerPage, setItemPerPage] = useState(10);
    const [selectedItem, setSelectedItem] = useState([]);
    const [isSelectAll, setIsSelectAll] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const isSidebarCollapsed = useSelector((state) => state.isSidebarCollapsed);
    const [paginationData, setPaginationData] = useState({ totalItems: 0, from: 0, to: 0, totalPages: 0 });
    const [sortBy, setSortBy] = useState("name");
    const [sortDirection, setSortDirection] = useState("asc");
    const [disableDelete, setDisableDelete] = useState(false);

    const listIds = leadsData?.map((el) => el.id);

    const handleSelectCheck = (id) => {
        if (selectedItem.length === 0) {
            setSelectedItem([id]);
        } else {
            const index = selectedItem?.indexOf(id);
            if (index === -1) {
                setSelectedItem([...selectedItem, id]);
            } else {
                const filterData = selectedItem?.filter((el) => el !== id);
                setSelectedItem(filterData);
            }
        }
    };

    const handleNext = () => {
        if (currentPage !== paginationData.totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const fetchData = () => {
        axios
            .get(`${BASE_URL}/lease-type-list?page=${currentPage}&per_page=${itemPerPage}&search=${search}&sort_direction=${sortDirection}&sort_by=${sortBy}`, config)
            .then((res) => {
              const leasetypeList = res?.data?.data?.leasetype_list;
                setLeadsData(leasetypeList?.data || []);
                setPaginationData({
                    totalItems: leasetypeList?.total ?? 0,
                    from: leasetypeList?.from ?? 0,
                    to: leasetypeList?.to ?? 0,
                    totalPages: leasetypeList?.last_page ?? 0,
                });
                setSelectedItem([]);
                setIsSelectAll(false);
            })
            .catch((err) => {
                console.error(err);
                if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
                    NotificationManager.error(err.response?.data?.message);
                }
            })
            .finally(() => {
                setLoading(false);
                setSelectedId("");
            });
    };

    useEffect(() => {
        fetchData();
    }, [sortBy, sortDirection]);

    useEffect(() => {
        onSuccess();
    }, [currentPage, itemPerPage, search]);

    const onSuccess = () => {
        setLoading(true);
        fetchData();
    };

    const handleDelete = () => {
        setDisableDelete(true);

        axios
            .delete(`${BASE_URL}/delete-lease-type/${selectedId}`, config)
            .then((res) => {
                setSelectedId("");
                onSuccess();
                setShowDeleteModal(false);
                if (res?.data?.message) {
                    NotificationManager.success(res?.data?.message);
                }
            })
            .catch((err) => {
                if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
                    NotificationManager.error(err.response?.data?.message);
                }
            })
            .finally(() => setDisableDelete(false));
    };

    return (
        <BaseLayout>
            <div className="contact-header mb-3">
                <p className="head-1 dark-H">
                    Lease Type
                    {selectedItem?.length > 0 && (
                        <span className="body-L ml-2">
                            ({selectedItem?.length} <span className="dark-H">{selectedItem?.length === 1 ? "item" : "items"} selected</span>)
                        </span>
                    )}
                </p>
            </div>

            <div className="md:flex justify-between items-center mb-4 mt-2 px-1">
                <div className="flex gap-4 items-center flex-wrap">
                    <div className="search-box contacts relative w-[250px]">
                        <input
                            type="text"
                            className="body-S w-full"
                            placeholder="search name here..."
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                            }}
                            style={{ border: "1px solid #D8D8D8", marginTop: "0px", width: "100%" }}
                        />
                    </div>
                </div>

                <div className="flex gap-2 items-center flex-wrap">
                    <button
                        className="add-contact-button green-bg-H light-L body-S"
                        onClick={() => {
                            setShowModal(true);
                        }}
                    >
                        <img className="mr-2 sidebar-icons" src={Plus} alt="plus" /> Add
                    </button>
                </div>
            </div>

            <div className="light-bg-L pb-3 table-container bg-white rounded-xl border border-gray-200 overflow-hidden relative min-h-[400px]">
              {loading && (
                <div className="absolute inset-0 z-10 flex justify-center items-center bg-white/40 backdrop-blur-[1px]">
                  <Loader />
                </div>
              )}
              <div className={`${isSidebarCollapsed ? "collapsed-width" : "width"} table-info light-bg-L`}>
                        <table className="contact-table two-rows-static light-bg-L">
                            <thead>
                                <tr className="uppercase body-N dark-M">
                                    {/* <th>
                                        <label className="container">
                                            <input
                                                type="checkbox"
                                                checked={leadsData?.length === 0 ? false : isSelectAll}
                                                onChange={(e) => {
                                                    setIsSelectAll(e.target.checked);
                                                    if (e.target.checked) {
                                                        setSelectedItem(listIds);
                                                    } else {
                                                        setSelectedItem([]);
                                                    }
                                                }}
                                            />
                                            <span className="checkmark"></span>
                                        </label>
                                    </th> */}
                                    <th className="green-H">
                                        <div className="table-header">
                                            Name
                                            <img
                                                role="button"
                                                src={sortBy !== "name" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                                                onClick={() => {
                                                    setSortBy("name");
                                                    if (sortDirection === "desc") {
                                                        setSortDirection("asc");
                                                    } else {
                                                        setSortDirection("desc");
                                                    }
                                                }}
                                                alt="icon"
                                            />
                                        </div>
                                    </th>
                                    <th>
                                        <div className="table-header">
                                            Created BY
                                            <img
                                                role="button"
                                                src={sortBy !== "user_id" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                                                onClick={() => {
                                                    setSortBy("user_id");
                                                    if (sortDirection === "desc") {
                                                        setSortDirection("asc");
                                                    } else {
                                                        setSortDirection("desc");
                                                    }
                                                }}
                                                alt="icon"
                                            />
                                        </div>
                                    </th>
                                    <th>
                                        <div className="table-header">
                                            Created On
                                            <img
                                                src={sortBy !== "created_at" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                                                alt="icon"
                                                onClick={() => {
                                                    setSortBy("created_at");
                                                    if (sortDirection === "desc") {
                                                        setSortDirection("asc");
                                                    } else {
                                                        setSortDirection("desc");
                                                    }
                                                }}
                                            />
                                        </div>
                                    </th>
                                    <th>
                                        <div className="table-header">Actions</div>
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {loading ? (
                                    [...Array(10)].map((_, idx) => (
                                        <tr key={idx} className="dark-H body-N">
                                            <td><Skeleton height="20px" width="140px" /></td>
                                            <td><Skeleton height="20px" width="140px" /></td>
                                            <td><Skeleton height="20px" width="140px" /></td>
                                            <td><Skeleton height="20px" width="40px" /></td>
                                        </tr>
                                    ))
                                ) : leadsData?.length === 0 ? (
                                    <tr>
                                        <td colSpan={4} className="body-N text-center mt-6 p-10 border-0">
                                            No Leads Found
                                        </td>
                                    </tr>
                                ) : (
                                    leadsData?.map((el, idx) => (
                                        <tr key={idx} className="dark-H body-N">
                                        {/* <td className="">
                                            <label className="container">
                                                <input
                                                    type="checkbox"
                                                    checked={selectedItem?.includes(el.id)}
                                                    onChange={() => {
                                                        handleSelectCheck(el.id);
                                                    }}
                                                />
                                                <span className="checkmark"></span>
                                            </label>
                                        </td> */}
                                        <td className="capitalize">{el?.name}</td>
                                        <td className="capitalize">
                                            {el?.created_by?.first_name} {el?.created_by?.last_name}
                                        </td>
                                        <td>
                                            {moment(el?.created_at).tz('America/New_York').format("MM/DD/YY")} <span className="dark-M body-S">{moment(el?.created_at).format("hh:mm A")}</span>
                                        </td>
                                        <td className="flex gap-3 items-center">
                                            <ActionsMenu
                                                handleEdit={() => {
                                                    setShowEditModal(true);
                                                    setSelectedId(el?.id);
                                                }}
                                                handleDelete={() => {
                                                    setSelectedId(el?.id);
                                                    setShowDeleteModal(true);
                                                }}
                                            />
                                        </td>
                                    </tr>
                                ))
                                )}
                            </tbody>
                        </table>
                </div>

                <AddLeadTypeModal showModal={showmodal} onClose={() => setShowModal(false)} onCallApi={onSuccess} />

                <EditLeadTypeModal
                    showModal={showEditModal}
                    onClose={() => setShowEditModal(false)}
                    id={selectedId}
                    onCallApi={() => {
                        setSelectedId("");
                        onSuccess();
                    }}
                />

                <DeleteConfirmationModal showModal={showDeleteModal} disable={disableDelete} onClose={() => setShowDeleteModal(false)} handleDelete={handleDelete} />

                <ContactPagination
                    from={"archive"}
                    setSelectedItem={setSelectedItem}
                    selectedItem={selectedItem}
                    paginationData={paginationData}
                    handleNext={handleNext}
                    handlePrev={handlePrev}
                    onSuccess={onSuccess}
                    itemPerPage={itemPerPage}
                    handleItemPerPageSelect={(value) => {
                        setItemPerPage(value);
                        setCurrentPage(1);
                    }}
                />
                <div className="px-6 pb-2">
                    <DataAsOfNotice  />
                </div>
            </div>
        </BaseLayout>
    );
};

export default LeadType;
